module.exports = __webpack_public_path__ + "img/L_307_0.c2c4e30f.png";